import motivationsData from '@/assets/data/motivations.js'
import operationalRoles from '@/assets/data/operationalRoles'
import cultureCharacteristics from '@/assets/data/cultureCharacteristics'
import personalityTypes from '@/assets/data/personalityTypes.js'
import tasks from '@/assets/data/tasks'

export function useAssessmentMapper() {
  const mapCulture = (cultureKey: any) => {
    return cultureCharacteristics.find(
      (culture: any) => culture.key === cultureKey,
    )
  }

  const mapMotivation = (motivationKey: any) => {
    return motivationsData.find(
      (motivation: any) => motivation.key === motivationKey,
    )
  }

  const mapOperationalRole = (operationalRoleKey: any) => {
    return operationalRoles.find(
      (operationalRole: any) => operationalRole.key === operationalRoleKey,
    )
  }

  const mapTask = (taskKey: any) => {
    return tasks.find((task) => task.key === taskKey)
  }

  const mapPersonalityType = (personalityTypeKey: any) => {
    return personalityTypes.find(
      (personalityType) => personalityType.code === personalityTypeKey,
    )
  }

  const mapCultures = (cultureKeys: any) => {
    return cultureKeys?.map((cultureKey: any) => mapCulture(cultureKey))
  }

  const mapMotivations = (motivationKeys: any) => {
    return motivationKeys?.map((motivationKey: any) =>
      mapMotivation(motivationKey),
    )
  }

  const mapOperationalRoles = (operationalRoleKeys: any) => {
    return operationalRoleKeys?.map((operationalRoleKey: any) =>
      mapOperationalRole(operationalRoleKey),
    )
  }

  const formatCognitiveLevels = (min: any, max: any) => {
    const formatLevel = (level: any) => {
      const uppercasedLevel = level.toUpperCase()
      return uppercasedLevel === 'WO_PLUS' ? 'WO+' : uppercasedLevel
    }

    if (min && max && min === max) return `${formatLevel(min)}`
    if (min && max) return `${formatLevel(min)} tot ${formatLevel(max)}`
    return min || max || null
  }

  const mapProfile = (profile: any) => {
    return {
      topMotivations: mapMotivations(
        profile?.motivationsRanking?.map(
          (motivation: any) => motivation.motivation,
        ),
      ),
      topCultures: mapCultures(
        profile?.topCultureRanking?.map(
          (culture: any) => culture.cultureCharacteristic,
        ),
      ),
      topOperationalRoles: mapOperationalRoles(
        profile?.rolesRanking?.map((role: any) => role.role),
      ),
      cognitiveLevels: [
        {
          label: formatCognitiveLevels(
            profile?.education?.min,
            profile?.education?.max,
          ),
        },
      ],
    }
  }

  return {
    mapCulture,
    mapMotivation,
    mapOperationalRole,
    mapTask,
    mapPersonalityType,
    mapCultures,
    mapMotivations,
    mapOperationalRoles,
    mapProfile,
  }
}
